<template>
    <div class="cascader" ref="cascader" v-click-outside:[el]="{all}">
        <div class="popover" v-if="isShow" ref="popover">
            <g-cascader-popover :loading-item="loadingItem" :list="options" :selectList="selectList" :load-data="loadData"></g-cascader-popover>
        </div>
        <div v-if="isDefaultSlots" ref="triggerWrapper" class="trigger" @click="toggle">
            <slot></slot>
        </div>
        <div v-else class="trigger"  ref="triggerWrapper" @click="toggle">{{newArr.join('/') || '请选择'}}</div>
    </div>
</template>

<script>
import Vue from 'vue'
import CascaderPopover from './cascader-popover'
import directives from '../directives'
export default {
    name: 'g-cascader',
    components: {
        'g-cascader-popover': CascaderPopover
    },
    props: {
        options: {
            type: Array
        },
        value: {
            type: Array,
            default: () => []
        },
        loadData: {
            type: Function
        }
    },
    data() {
        return {
            el:'popover',
            all:this,
            isShow: false,
            eventBus: new Vue(),
            selectList: this.value,
            loadingItem: {}
        }
    },
    directives: {
        'click-outside':directives['click-outside']
    },
    provide() {
        return {
            eventBus: this.eventBus
        }
    },
    methods: {
        filterArr(arr, index, newArr = []) {
            if (!arr instanceof Array) {
                return
            }
            arr.forEach(item => {
                if (item.name === this.value[index]) {
                    newArr.push(item)
                    if (item.children) {
                        const num = index + 1
                        if (num <= this.value.length) {
                            this.filterArr(item.children, num, newArr)
                        }
                    }
                }
            })
        },
        findItem(arr,id) {
            let obj = {}
            let yy = (arr,id) => {
                for(let i = 0;i<arr.length>0;i++) {
                    if(arr[i].id == id) {
                        obj = arr[i]
                        return
                    }
                    arr[i].children && arr[i].children.length && yy(arr[i].children,id)
                }
            }
            yy(arr,id)
            return obj
        },
        open(e) {
            this.isShow = true
                this.$nextTick(() => {
                    this.setPosition()
                })
        },
        close() {
            this.isShow = false
        },
        toggle() {
            if (this.isShow) {
                this.close()
            } else {
                this.open()
            }
        },
        getStyleObj(width, height, top, left) {
            return {
                left: `${left+window.scrollX}px`,
                top: `${top+window.scrollY+height}px`
            }
        },
        setPosition() {
            document.body.appendChild(this.$refs.popover)
            const { width, height, top, left } = this.$refs.triggerWrapper.getBoundingClientRect()
            const popoverStyle = this.$refs.popover.style

            const obj = this.getStyleObj(width, height, top, left )
            popoverStyle.left = obj.left
            popoverStyle.top = obj.top
        }
    },
    mounted() {
        const arr = []
        this.filterArr(this.options, 0, arr)
        this.selectList = arr
        this.eventBus.$on('change', (index, item) => {
            const arr = JSON.parse(JSON.stringify(this.options))
            const upDateItem = this.findItem(arr,item.id)
            const cb = result => {
                this.loadingItem = {}
                if (result.length > 0) {
                    upDateItem.children = result
                    this.$emit('update:options',arr)
                }
            }

            if(this.loadData && !item.isLeaf) {
                this.loadData(item, cb)
                this.loadingItem = item
            }
            this.$set(this.selectList,index,upDateItem)
            this.selectList.splice(index + 1)
            this.$emit('input', this.newArr)
        })
    },
    computed: {
        newArr() {
            return this.selectList.map(item => {
                return item.name
            })
        },
        isDefaultSlots() {
            return this.$slots.default ? true : false
        }
    },
    watch: {
        value(newValue) {
            const arr = []
            this.filterArr(this.options, 0, arr)
            this.selectList = arr
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../var';
.cascader {
    position: relative;
    display: inline-flex;
    > .popover {
        position: absolute;
        background:#fff;
        // top: 100%;
        @extend .box-shadow;
        margin-top: 4px;
    }
    > .trigger {
        border: 1px solid $border-color;
        height: $height;
        display: inline-flex;
        align-items: center;
        min-width: 10em;
        padding: 0 1em;
        border-radius: $border-radius;
    }
}
.popover {
    position: absolute;
    background:#fff;
    // top: 100%;
    @extend .box-shadow;
    margin-top: 4px;
}
</style>